// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names, func-style, prefer-template, no-plusplus, object-shorthand, prefer-rest-params, no-unused-expressions, no-sequences */
// Source: https://gist.github.com/k-gun/c2ea7c49edf7b757fe9561ba37cb19ca

;(function() {
  // helpers
  const regExp = function(name) {
    return new RegExp("(^| )" + name + "( |$)")
  }
  const forEach = function(list, fn, scope) {
    for (let i = 0; i < list.length; i++) {
      fn.call(scope, list[i])
    }
  }

  // class list object with basic methods
  function ClassList(element) {
    this.element = element
  }

  ClassList.prototype = {
    add: function() {
      forEach(
        arguments,
        function(name) {
          if (!this.contains(name)) {
            this.element.className += this.element.className.length > 0 ? " " + name : name
          }
        },
        this,
      )
    },
    remove: function() {
      forEach(
        arguments,
        function(name) {
          this.element.className = this.element.className.replace(regExp(name), "")
        },
        this,
      )
    },
    toggle: function(name) {
      return this.contains(name) ? (this.remove(name), false) : (this.add(name), true)
    },
    contains: function(name) {
      return regExp(name).test(this.element.className)
    },
    replace: function(oldName, newName) {
      this.remove(oldName), this.add(newName)
    },
  }

  // IE8/9, Safari
  if (!("classList" in Element.prototype)) {
    Object.defineProperty(Element.prototype, "classList", {
      get: function() {
        return new ClassList(this)
      },
    })
  }

  // replace() support for others
  if (window.DOMTokenList && DOMTokenList.prototype.replace == null) {
    DOMTokenList.prototype.replace = ClassList.prototype.replace
  }
})()

